import { readObject, writeObject } from "../../../root/punks/utils/storage"

const WISHLIST_STORAGE_KEY = "__wishlist_id"

export const persistWishlistId = (id: string) =>
  writeObject(WISHLIST_STORAGE_KEY, id)

export const readWishlistId = () => readObject<string>(WISHLIST_STORAGE_KEY)
